// extracted by mini-css-extract-plugin
export default {"base":"Tab_base__4t93a","lukoil":"Tab_lukoil__hJhsL","tab_list":"Tab_tab_list__nCj2C","tab":"Tab_tab__snsc7","active":"Tab_active__bSmQe","tab_panel":"Tab_tab_panel__HSVbq"};